var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.229169 13.22917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 730.09198,
    y1: 380.4028,
    x2: 823.03943,
    y2: 287.45529,
    gradientTransform: "translate(-189.07734,-67.619864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#FFFFFF"
    },
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    },
    id: "stop8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 745.40363,
    y1: 399.21771,
    x2: 838.35101,
    y2: 306.2702,
    gradientTransform: "rotate(180,689.76728,289.07747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#FFFFFF"
    },
    id: "stop13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    },
    id: "stop15"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g1118",
    transform: "matrix(0.07318996,0,0,0.07318996,-36.389835,-11.379909)",
    style: {
      strokeWidth: 0.90848
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 524.99266,231.48014 -26.23,30.07 h 13.53 c 0,0 4.89,49.1 53.5,62.24 21.45,5.8 44.51,2.92 64.01,-7.72 13.84,-7.55 29.03,-20.15 37.18,-40.82 l 7.02,-15.37 -25.06,-7.02 c 0,0 -13.36,47.78 -59.47,49.11 -46.11,1.33 -51.12,-41.09 -51.12,-41.09 h 15.37 z",
    id: "path11",
    style: {
      fill: "url(#SVGID_1_)",
      strokeWidth: 0.90848
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 650.15266,260.24014 26.23,-30.07 h -13.53 c 0,0 -4.89,-49.1 -53.5,-62.24 -21.45,-5.8 -44.51,-2.92 -64.01,7.72 -13.84,7.55 -29.03,20.15 -37.18,40.82 l -7.02,15.37 27.82,-0.36 c 0,0 10.6,-40.4 56.71,-41.73 46.11,-1.34 51.12,41.09 51.12,41.09 h -15.37 z",
    id: "path18",
    style: {
      fill: "url(#SVGID_2_)",
      strokeWidth: 0.90848
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin);
export default __webpack_public_path__ + "static/media/spin.38ee244795d35da5a9f29265ef1836a5.svg";
export { ForwardRef as ReactComponent };